<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :stroke-width="stroke_width || '2'" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" fill="none" viewBox="0 0 26 26" style="enable-background:new 0 0 26 26;" xml:space="preserve" :class="class">
        <g>
            <path d="M18.7,24.4c3.3,0,6-2.7,6-6s-2.7-6-6-6-6,2.7-6,6,2.7,6,6,6Z"/>
            <path d="M21.4,16.7l-2.9,3.9c-.1.2-.3.3-.5.3-.2,0-.4,0-.6-.2l-1.5-1.5"/>
            <path d="M5.2,7.9h10.5"/>
            <path d="M5.2,12.4h6"/>
            <path d="M5.2,16.9h3.8"/>
            <path d="M9,21.4H3.7c-.8,0-1.5-.7-1.5-1.5V3.4c0-.8.7-1.5,1.5-1.5h10.6c.4,0,.8.2,1.1.4l2.9,2.9c.3.3.4.7.4,1.1v2.4"/>
        </g>
    </svg>
</template>

<script>
export default {
    props: ['class', 'stroke_width'],
}
</script>